<template>
  <div v-if="exitflag" id="app">
    <router-view :nowlogin="nowlogin" />
    <!--
      手机上浏览电脑版时的返回入口。
      没有它，用户点过一次「切换到电脑版」就永久回不去手机版了 —— viewMode 存在
      localStorage 里，下次打开网站还是电脑版。仅在手机 UA 下渲染，电脑端不受影响。
    -->
    <button
      v-if="showBackToMobile"
      class="m-back-to-mobile"
      @click="backToMobile"
    >手机版</button>
  </div>
  <!-- <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;" v-else-if="!exitflag">
    <div style="text-align: center;        
                      font-size:30px;
                      letter-spacing: 15px;
                      color: brown;"> <div>暂不支持Edge浏览器使用</div>
       
    
    <div>推荐使用谷歌浏览器, <a @click="getannex('https://3class.oss-cn-hangzhou.aliyuncs.com/appVersion/udTIChChromeSetup.exe')" href="#">点击下载</a> </div> </div>
  </div> -->
</template>

<script>
import {
detail
} from "@/utils/api/user.js";
import Watermark from '@/common/js/wartermark.js';
import { isMobileUA, isMobileRoute, setViewMode } from '@/utils/device'
import { resolveMobilePath } from '@/router/mobile-map'

import { init } from 'console-ban'
init({
  redirect: 'https://www.bilibili.com/video/BV1uT4y1P7CX/'
})
// /* eslint-disable spaced-comment */
// /*!
//   devtools-detect
//   Detect if DevTools is open
//   https://github.com/sindresorhus/devtools-detect
//   by Sindre Sorhus
//   MIT License
//   comment by CC11001100
// */


if (window.location.hostname != "127.0.0.1") {
  document.onkeydown = () => {
    //禁用F12
    if (window.event && window.event.keyCode == 123) {
      return false;
      //禁用ctrl+shift+i,
    } else if (
      window.event.ctrlKey &&
      window.event.shiftKey &&
      window.event.keyCode == 73
    ) {
      return false;
      //屏蔽Shift+F10     
    } else if (window.event.shiftKey && window.event.keyCode == 121) {
      return false;
    }
  };
}

// console.log(navigator.plugins)
function loadStyleString(cssText) {
        var style = document.createElement("style");
        style.type = "text/css";
        try {
          // firefox、safari、chrome和Opera
          style.appendChild(document.createTextNode(cssText));
        } catch (ex) {
          // IE早期的浏览器 ,需要使用style元素的stylesheet属性的cssText属性
          style.styleSheet.cssText = cssText;
        }
        document.getElementsByTagName("head")[0].appendChild(style);
      }
export default {
  name: "App",
  computed: {
    showBackToMobile() {
      return isMobileUA() && !isMobileRoute(this.$route.path)
    }
  },
  created(){
    this.setwater()
    console.log(navigator.userAgent)
    
    var userAgent = navigator.userAgent;

  },
  methods:{
    backToMobile() {
      setViewMode('mobile')
      // 尽量落到当前页对应的移动端页面，没有对应页的会兜底回首页
      const target = resolveMobilePath(this.$route.path, this.$route.query)
      this.$router.replace({ path: target.path, query: target.query })
    },

    async setwater(){
      if (localStorage.getItem("id") != undefined) {
          let data = await detail();
              if (data.code != 0) {
                this.$notify.error({
                  title: "错误",
                  message: "用户信息获取失败!",
                });
                return
              } else {
                localStorage.setItem("idcard", data.data.idCard);
                localStorage.setItem("username", data.data.username);
                localStorage.setItem("id", data.data.id);
                localStorage.setItem("phone", data.data.phone);
                localStorage.setItem("slogan", data.data.slogan);
                localStorage.setItem("head_img", data.data.head_img);
                localStorage.setItem("role", data.data.role);
                localStorage.setItem("realName", data.data.realName)
                this.nowlogin = true

                

                Watermark.set(data.data.id)
              }
      }else{
        this.nowlogin = false
        Watermark.set('3C课堂')
      }
    },

    
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };

        xhr.send();
      });
    },
    getannex(file_url) {
      this.getBlob(file_url).then((blob) => {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = 'ChromeSetup.exe'
        link.click();
      });
    },
    exit() {
      this.exitflag = false
    }
  },
  mounted() {
  
  


      //   let flag =             navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

      // if (flag) {
      //   // 手机
      //   window.location.href = "https://www.pgyer.com/A3r0k7"
      //   console.log(1)
      // } else {
      //   // windows
      //   console.log(2)
      // }

  },
  data() {
    return {nowlogin:false,
      exitflag:true,
      windowHeight: 0,
      windowWidth: 0,
    };
  },
};
</script>
<style>
#app {
  height: 100%;
}

/*
  只在手机 UA 下渲染，所以这段样式在电脑端永远不会生效。
  尺寸按 PC 版 1224px 布局被整体缩放后的观感调大了一些，保证手指点得中。
*/
.m-back-to-mobile {
  position: fixed;
  right: 16px;
  bottom: 24px;
  z-index: 9999;
  height: 56px;
  padding: 0 28px;
  border: none;
  border-radius: 28px;
  background: rgba(52, 114, 255, 0.94);
  color: #fff;
  font-size: 22px;
  line-height: 56px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.m-back-to-mobile:active {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue